import { Outlet } from 'react-router-dom';
import SimpleNavigation from '../sections/SimpleNavigation';

// Marketing layout uses simple top navigation for public pages
export default function MarketingLayout() {
  return (
    <div className="relative bg-navy min-h-screen">
      <div className="noise-overlay" />
      <SimpleNavigation />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
